import * as UrlConstants from '@/constants/url-constants'

export default class StageDeterminerService {
    isStage(): boolean {
        const urlParams = new URLSearchParams(window.location.search)
        const hasStageUrl = urlParams.has(UrlConstants.stageEnvironment) && urlParams.get(UrlConstants.stageEnvironment) == 'true'
        const isSim2 = window.location.href.includes('sim2.raraya.co.jp')
        return hasStageUrl || isSim2
    }

    isProd(): boolean {
        const urlParams = new URLSearchParams(window.location.search)
        const hasStageUrl = urlParams.has(UrlConstants.stageEnvironment) && urlParams.get(UrlConstants.stageEnvironment) == 'true'
        const isSim2 = window.location.href.includes('sim.raraya.co.jp')
        return hasStageUrl || isSim2
    }

    isColorpickerVisible(): boolean {
        if (this.isProd()) {
            return false
        }
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("colorpicker") && JSON.parse(urlParams.get("colorpicker") || "false") == true) {
            return true;
        }
        return false
    }
}